import OperationalHistory from './OperationalHistory';

export default OperationalHistory;
